
export class GetTaskCommentsInputDto {
    taskId: string;
}
